import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=19e5e566&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e5e566')) {
      api.createRecord('19e5e566', component.options)
    } else {
      api.reload('19e5e566', component.options)
    }
    module.hot.accept("./BaseButton.vue?vue&type=template&id=19e5e566&", function () {
      api.rerender('19e5e566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseButton.vue"
export default component.exports